import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Mutations } from 'apollo';

const useOktaVerifyFactorRequest = () => {
  const client = useApolloClient();
  const enroll = useCallback(
    loginId =>
      client
        .mutate({
          mutation: Mutations.enrollOktaVerifyFactor,
          variables: { loginId },
        })
        .then(response => response.data.enrollOktaVerifyFactor),
    [client],
  );
  // we will use the same activation mutation as the phone factor
  // because it will be the same result
  const activate = useCallback(
    (loginId, factorId, code) =>
      client
        .mutate({
          mutation: Mutations.activatePhoneFactor,
          variables: { loginId, factorId, code, activateBoth: false },
        })
        .then(response => response.data.activatePhoneFactor),
    [client],
  );
  return { enroll, activate };
};

export default useOktaVerifyFactorRequest;
